import { RootState } from '../../app/store';

export const selectLoaderComplete = (state: RootState) => state.loader.complete;
export const selectLoaderProgress = (state: RootState) => state.loader.progress;
export const selectLoaderError = (state: RootState) => state.loader.error;
